import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Calendar, User } from "lucide-react";
import Wordmark from "./Wordmark";
import ConsultationModal from "./ConsultationModal";
import SignInModal from "./SignInModal";
import MegaMenu from "./MegaMenu";
import MobileNav from "./MobileNav";
import { useUserAuth } from "../lib/userAuth";

export default function Header({ onConsultClick }) {
  const { t } = useTranslation();
  const loc = useLocation();
  const [showConsult, setShow] = useState(false);
  const [showSignIn, setShowSignIn] = useState(false);
  const { account } = useUserAuth();
  const open = () => (onConsultClick ? onConsultClick() : setShow(true));

  const source = `header-${loc.pathname === "/" ? "landing" : loc.pathname.replace(/^\/+/, "").split("/")[0]}`;

  return (
    <>
      <header
        data-testid="site-header"
        className="sticky top-0 z-40 qt-no-print"
        style={{ background: "#04091A", borderBottom: "1px solid var(--qt-cyan)", boxShadow: "0 1px 12px rgba(0, 229, 255, 0.18)" }}
      >
        <div className="max-w-[1400px] mx-auto px-6 sm:px-8 h-16 flex items-center justify-between gap-3">
          <Link to="/" data-testid="header-logo-link" className="flex items-center gap-3">
            <Wordmark size={20} />
          </Link>

          <div className="hidden lg:flex items-center">
            <MegaMenu />
          </div>

          <div className="flex items-center gap-1">
            <button
              onClick={open}
              data-testid="header-consult-cta"
              className="qt-btn qt-btn-secondary"
              style={{ fontSize: 13, padding: "0.5rem 0.875rem" }}
            >
              <Calendar size={14}/> <span className="hidden sm:inline">{t("nav.consult", "Consult")}</span>
            </button>
            {account ? (
              <Link
                to="/account"
                data-testid="header-account-link"
                className="qt-btn qt-btn-ghost"
                title={`${account.email} · ${(account.plan || 'free').toUpperCase()}`}
                style={{ fontSize: 13, padding: "0.5rem 0.75rem", border: "1px solid var(--qt-border)" }}
              >
                <User size={14} />
                <span className="qt-mono text-xs ml-1 hidden sm:inline" style={{ color: "var(--qt-cyan)", letterSpacing: "0.1em" }}>
                  {(account.plan || "free").toUpperCase()}
                </span>
              </Link>
            ) : (
              <button
                type="button"
                onClick={() => setShowSignIn(true)}
                data-testid="header-signin-link"
                className="qt-btn qt-btn-ghost"
                style={{ fontSize: 13, padding: "0.5rem 0.75rem", border: "1px solid var(--qt-border)" }}
              >
                <User size={14} /> <span className="hidden sm:inline">{t("nav.signin", "Sign in")}</span>
              </button>
            )}
            <MobileNav />
          </div>
        </div>
      </header>
      {!onConsultClick && <ConsultationModal open={showConsult} onClose={() => setShow(false)} source={source} />}
      <SignInModal open={showSignIn} onClose={() => setShowSignIn(false)} defaultMode="login" />
    </>
  );
}
